import React from 'react'
import classNames from 'classnames'

import { INativeSelectProps } from './types'

function NativeSelectComponent<T>(
  {
    name,
    label,
    options,
    required,
    className,
    placeholder,
    placeholderDisabled,
    ...rest
  }: INativeSelectProps<T>,
  ref: React.ForwardedRef<HTMLSelectElement>,
) {
  return (
    <div className={classNames('vehicle-dropdown', className)}>
      {!!label && <label htmlFor={name}>{label}</label>}
      <select {...rest} ref={ref} id={name}>
        {!!placeholder && (
          <option value="default" disabled={placeholderDisabled}>
            {placeholder}
          </option>
        )}
        {options.map((option, idx) => (
          // @ts-ignore
          <option key={idx} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  )
}

export const Select = React.forwardRef(NativeSelectComponent)

Select.displayName = 'Select'
